import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiIconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Grow from '@material-ui/core/Grow';

import { removeKeys } from '../../../utils';

const IconButton = withStyles(theme => ({
    root: props => ({
        backgroundColor: props.backgroundColor,
        '&:hover': {
            backgroundColor: props.backgroundColor,
            '& > .MuiIconButton-label': {
                '& > $hoverRipple': {
                    transform: 'scale(1)',
                },
                '& > .MuiSvgIcon-root': {
                    ...props.iconHoverStyle,
                },
            },
        },
        '& > .MuiTouchRipple-root': {
            color: props.rippleColor,
        },
        '& > .MuiIconButton-label > .MuiSvgIcon-root': {
            zIndex: 1,
            transition: 'transform 0.15s ease',
        },
        ...props.rootStyles,
    }),
    hoverRipple: props => ({
        borderRadius: 24,
        transform: 'scale(0)',
        transition: 'transform 0.15s ease',
        backgroundColor: props.hoverRippleColor,
        ...props.hoverRippleStyles,
    }),
}))(React.memo(({ /*ignored prop*/title, colorMode, backgroundColor, hoverRippleColor, hoverRippleStyles, iconHoverStyle, rippleColor, classes, icon, rootStyles, children, tooltip, tooltipProps, ...props }) => {
    const finalClasses = removeKeys(classes, ['hoverRipple', 'hoverRippleStyles']);
    return props.disabled ?
        <Tooltip TransitionComponent={Grow} title={tooltip || ''} {...tooltipProps}>
            <span><MuiIconButton {...props} classes={finalClasses}>
                <div className={`${classes.hoverRipple} fillSpace`} />
                {children}
            </MuiIconButton></span>
        </Tooltip>
        :
        <Tooltip TransitionComponent={Grow} title={tooltip || ''} {...tooltipProps}>
            <MuiIconButton {...props} classes={finalClasses}>
                <div className={`${classes.hoverRipple} fillSpace`} />
                {children}
            </MuiIconButton>
        </Tooltip>;
}));

IconButton.defaultProps = {
    backgroundColor: 'transparent',
    hoverRippleColor: 'var(--hover-ripple)',
    rippleColor: 'var(--ripple)',
};

export default IconButton;